<template>
    <div>
        <PageHeader :title="pageHeader">
            <template v-slot:icon>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="page-header-icon">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
            </template>
        </PageHeader>

		<div class="grid grid-cols-3 gap-4">
			<!-- EMPRESA -->
            <div class="bg-white mt-2 p-4">
                <div class="flex mb-2">
                    <h1 class="text-gray-600 font-semibold text-lg">Cliente:</h1>
                    <svg v-if="loadingCompanies" class="animate-spin ml-1 mt-1 mr-3 h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                </div>
                <SimpleTypeahead
                    :disabled="loadingCompanies"
                    ref="typeaheadRef"
                    id="typeahead_id"
                    placeholder="Nome da Empresa"
                    :items="companies"
                    :itemProjection="company => company.title"
                    :minInputLength="1"
                    @selectItem="onSelectCompany"
                ></SimpleTypeahead>
            </div>
			<!-- Compoetência -->
			<div class="bg-white mt-2 p-4" v-if="filter.company">
				<div class="flex flex-col">
					<h1 class="text-gray-600 mb-2 font-semibold text-lg">Competência</h1>
					<Datepicker locale="pt-BR" :enableTimePicker="false" format="dd/MM/yyyy" v-model="filter.competence_date" autoApply @update:modelValue="onSelectCompetence" />
				</div>
			</div>
			<div class="bg-white mt-2 p-4" v-if="filter.company && showExportClimate">
				<div class="flex flex-col">
					<h1 class="text-gray-600 mb-2 font-semibold text-lg">Exportar</h1>
					<BaseButton @click="generateClimateSurveyReport()" skin="primary-small" class="mb-4">
						<svg v-if="loadingReport" class="animate-spin ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
							<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
							<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
						</svg>
						Exportar Pesquisa de Clima
					</BaseButton>
				</div>
			</div>
			<!-- Pessoa individualemnte-->
			<!-- <div v-if="people.slice(1).length > 0 && selectedGroup?.type !== '360'" class="bg-white mt-2 p-4">
				<label class="text-gray-600 mb-2 font-semibold text-lg">Filtrar por pessoa</label>
				<select v-model="selectedPerson" class="border border-gray-300 rounded p-2 text-sm mt-2.5">
					<option v-for="person in people" :key="person.id" :value="person.id">
						{{ person.name }}
					</option>
				</select>
			</div> -->
		</div>

		<!-- Loading Skeleton-->
		<div v-if="loadingSearchResult" class="mt-4 mx-auto w-full rounded-md p-4 mb-4">
			<div class="flex animate-pulse space-x-4">
				<div class="size-10 rounded-full bg-gray-300"></div>
				<div class="flex-1 space-y-6 py-1">
				<div class="h-2 rounded bg-gray-300"></div>
				<div class="space-y-3">
					<div class="grid grid-cols-3 gap-4">
					<div class="col-span-2 h-2 rounded bg-gray-300"></div>
					<div class="col-span-1 h-2 rounded bg-gray-300"></div>
					</div>
					<div class="h-2 rounded bg-gray-300"></div>
				</div>
				</div>
			</div>
		</div>

		<div class="bg-white p-4 grid grid-cols-3 h-32 mt-4 gap-y-3 gap-x-3 h-auto">
			<div @click="showResults(block)" v-for="block in resultBlocks.groups" :key="block.group_uuid" class="hover:bg-green-50 cursor-pointer border-2 border-green-600 flex flex-col gap-y-2 items-center justify-center">
				<span class="text-green-600 font-semibold text-base">Enviado em {{ defaultDate(block.created_at) }}</span>
				<div class="bg-green-600 px-2 text-xs text-white rounded-lg">
					{{
						block.type === 'default' ? 'Padrão'
						: block.type === 'climate' ? 'Clima'
						: block.type === '360' ? 'Avaliação 360'
						: block.type === 'pdi' ? 'PDI'
						: block.type
					}}
				</div>
				<span class="text-green-800 font-semibold text-lg">Nº de respostas: {{ getCompletedCount(block.data) }} / {{ block.data?.length }}</span>
			</div>
		</div>

		<!-- Resultados-->
		<div class="grid grid-cols-1 gap-6 mt-4">
			<div v-for="(item, idx) in filteredResults" :key="idx" class="bg-white p-4 rounded shadow">
				<h3 class="text-gray-800 font-semibold text-md mb-2">
					{{ item.label }}
					<span
						v-if="selectedGroup?.type === '360' && item.target_worker_name"
						class="text-gray-500 ml-2 text-sm"
					>
						(Para: {{ item.target_worker_name.toUpperCase() }})
					</span>
				</h3>

				<!-- BAR CHART -->
				<BarChart v-if="getChartType(item) === 'bar'" :chartData="getBarChartData(item.answers)" :options="chartOptions" class="h-48" />

				<!-- PIE CHART -->
				<PieChart
					v-if="getChartType(item) === 'pie'"
					:chartData="getPieChartData(item.answers, item)"
					:options="pieOptions"
					class="h-64"
				/>
				<!-- Lista das opções com contagem -->
				<div
					v-if="getChartType(item) === 'pie' && item.options?.length"
					class="mt-4 grid grid-cols-2 sm:grid-cols-3 gap-x-6 gap-y-2 text-sm text-gray-700"
				>
					<div
						v-for="(opt, idx) in item.options"
						:key="idx"
						class="flex justify-between border-b pb-1"
					>
						<span class="font-medium">{{ opt.label }}</span>
						<span>
							{{ getCountForLabel(opt.label, item.answers) }} resposta(s)
							({{ getPercentageForLabel(opt.label, item.answers) }}%)
						</span>
					</div>
				</div>

				<!-- TEXT -->
				<div v-if="getChartType(item) === 'text'" class="mt-4">
					<div v-for="(answer, aIdx) in item.answers" :key="aIdx" class="mb-2">
						<p class="text-gray-800">{{ answer }}</p>
						<hr class="my-2 border-gray-200" />
					</div>
				</div>
			</div>
		</div>

        <!-- Content -->
         <Alert class="mt-4" text="Nenhuma Pesquisa nessa data de competência" :show="!resultBlocks.groups?.length && !loadingSearchResult" />
    </div>
</template>

<script>
    import { ref, onMounted, watch, computed } from 'vue';
    import { useRoute, useRouter } from 'vue-router';
    import Swal from 'sweetalert';
    import Alert from '@/components/Alert';
    import UtilService from '../services/UtilService';
    import { defaultDate } from '../filters/date';
	import SimpleTypeahead from 'vue3-simple-typeahead';
	import { DateTime } from 'luxon';
	import { CompanyService, DispatchService } from '../services/Entity';
	import { BarChart, PieChart } from 'vue-chart-3';
	import { Chart, registerables } from 'chart.js';
	import ReportService from '../services/Entity/ReportService';
	

	Chart.register(...registerables);

    export default {
        name: 'Forms',
        components: {
            SimpleTypeahead,
            Alert,
			BarChart,
			PieChart
        },
        setup() {
            const isEdit = ref(false);
            const pageHeader = ref('Resultados Formulários');
            const loading = ref(false);
			const loadingCompanies = ref(false);
			const companies = ref([]);
			const competenceDate = ref();
			const router = useRouter();
			const loadingSearchResult = ref(false);
			const allResults = ref([]);
			const filter = ref({
				competence_date: null,
				company:null
			});
			const loadingReport = ref(false);
			const resultBlocks = ref([]);
			const selectedGroup = ref(null);
			const groupedCharts = ref([]);
			const textAnswers = ref([]);
			const people = ref([]);
			const selectedPerson = ref('all');
			const showExportClimate = ref(false);
			const chartOptions = ref({
				responsive: true,
				plugins: {
					legend: { display: false },
					tooltip: {
						callbacks: {
							label: ctx => `${ctx.raw} respostas (${ctx.dataset.percentages[ctx.dataIndex]}%)`
						}
					}
				},
				scales: {
					y: {
						beginAtZero: true,
						precision: 0
					}
				}
			});
			const pieOptions = ref({
				responsive: true,
				plugins: {
					legend: {
						position: 'bottom'
					},
					tooltip: {
						callbacks: {
							label: ctx => `${ctx.raw} respostas (${ctx.dataset.percentages[ctx.dataIndex]}%)`
						}
					}
				}
			});

			const filteredResults = computed(() => {
				if (selectedPerson.value === 'all') return allResults.value;

				return allResults.value.filter(item => item.target_worker_id === Number(selectedPerson.value));
			});

            onMounted(async () => {
                const allCompanies = await listCompanies();

				for (let company of allCompanies) {
                    companies.value.push({
                        title: company.name,
                        value: company.id
                    });
                }
            });
			
			function getChartData(distribution) {
				return {
					labels: distribution.map(d => d.label),
					datasets: [{
						label: 'Respostas',
						backgroundColor: '#10B981',
						data: distribution.map(d => d.count),
						percentages: distribution.map(d => d.percentage)
					}]
				};
			}

			async function listCompanies(page = 1, limit = 9999) {
                try {
                    loadingCompanies.value = true;
                    const { data: { items } } = await CompanyService.list(page, limit, {});
                    loadingCompanies.value = false;

                    return items;
                } catch(err) {
                    loadingCompanies.value = false;
                    loading.value = false;
                    console.log(err);
                    Swal({
                        title: 'Ocorreu um erro ao obter dados dos clientes',
                        text: 'Atualize a página e tente novamente',
                        icon: 'error'
                    });
                }
            }
			
            function onSelectCompany(company) {
				if (!company || !company.value) {
                    return;
                }

				filter.value.company = company.value;
			}
			
			async function onSelectCompetence(competenceDate) {
				const selectedDate = normalizeToISO(competenceDate);

				if (!selectedDate) {
					Swal({
                        title: 'Data Inválida',
                        icon: 'Warning'
                    });
				}

				await listSendGroups(filter.value);
			}

			async function listSendGroups(filter) {
                try {
					filter.competence_date = normalizeToISO(filter.competence_date);

                    loadingSearchResult.value = true;
                    const { data } = await DispatchService.listSendGroups(filter.company, filter.competence_date);
					resultBlocks.value = data;

                    loadingSearchResult.value = false;

                } catch(err) {
                    loadingSearchResult.value = false;
                    loading.value = false;
                    console.log(err);
                    Swal({
                        title: 'Ocorreu um erro ao obter dados dos envios',
                        text: 'Atualize a página e tente novamente',
                        icon: 'error'
                    });
                }
            }

			function normalizeToISO(date) {
				if (!date) return null;

				if (date instanceof Date) {
					return DateTime.fromJSDate(date).toISODate();
				}

				if (DateTime.isDateTime(date)) {
					return date.toISODate();
				}

				return null;
			}

			function showResults(group) {
				selectedGroup.value = group;

				if (group.type === '360') {
					groupedCharts.value = buildGroupedScoreByTarget(group);
					textAnswers.value = extractTextAnswers(group);
				} else {
					groupedCharts.value = null;
					textAnswers.value = [];
				}

				if (group.type === 'climate') {
					showExportClimate.value = true;
				}

				allResults.value = extractAllAnswers(group);

				const seen = new Set();
				people.value = [
					{ name: 'Todas as pessoas', id: 'all' },
					...group.data.flatMap(d =>
						(d.form_structure?.structure || [])
						.filter(f => f.target_worker_id && f.target_worker_name)
						.map(f => ({ id: f.target_worker_id, name: f.target_worker_name }))
					)
					.reduce((acc, curr) => acc.some(p => p.id === curr.id) ? acc : [...acc, curr], [])
				];
				selectedPerson.value = 'all';

				console.log('>> Primeiro dispatch:', group.data?.[0])
			}

			function extractTextAnswers(group) {
				const result = {};

				group.data.forEach(dispatch => {
					const structure = dispatch.form_structure?.structure || [];

					const textFields = structure.filter(f =>
						['text', 'textarea', 'long_text'].includes(f.type) &&
						f.answer &&
						f.label &&
						f.target_worker_id // <- isso garante que tem relação com uma pessoa
					);

					textFields.forEach(field => {
						const targetId = field.target_worker_id;

						if (!result[targetId]) {
							result[targetId] = [];
						}

						result[targetId].push({
							label: field.label,
							answer: field.answer
						});
					});
				});

				return result; // agora é um objeto { target_worker_id: [respostas...] }
			}

			function extractAllAnswers(group) {
				const results = [];

				group.data.forEach(dispatch => {
					const structure = dispatch.form_structure?.structure || [];

					structure.forEach(field => {
						if (!field.label || !field.type) return;

						let rawAnswer;
						if (field.type === 'checkbox') {
							rawAnswer = (field.options || [])
								.filter(opt => opt.answer === true)
								.map(opt => opt.label);
							if (rawAnswer.length === 0) return;
						} else {
							rawAnswer = field.answer;
							if (rawAnswer == null || rawAnswer === '') return;
						}

						const is360 = group.type === '360';
						const key = is360
							? `${field.label}::${field.target_worker_id || 'global'}`
							: field.label;

						let existing = results.find(r => r.key === key);

						if (!existing) {
							existing = {
								key,
								label: field.label,
								type: field.type,
								target_worker_id: field.target_worker_id || null,
								target_worker_name: field.target_worker_name || null,
								answers: [],
								dispatch_uuid: dispatch.uuid,
								options: field.options || [] // ✅ adiciona aqui
							};
							results.push(existing);
						}

						existing.answers.push(rawAnswer);
					});
				});

				return results;
			}

			function buildGroupedScoreByTarget(group) {
				const result = {};

				group.data.forEach(dispatch => {
					const structure = dispatch.form_structure?.structure || [];

					const fixedFields = structure.filter(f =>
						f.type === 'multiple_choice' &&
						f.fixed === true &&
						f.target_worker_id
					);

					fixedFields.forEach(field => {
						const targetId = field.target_worker_id;

						if (!result[targetId]) {
							result[targetId] = {
								label: field.label,
								target_worker_name: field.target_worker_name || null,
								uuid: dispatch.uuid,
								map: { '1': 0, '2': 0, '3': 0, '4': 0, '5': 0, '6': 0, '7': 0, '8': 0, '9': 0, '10': 0 }
							};
						}

						const answer = String(field.answer)?.trim();

						if (answer && result[targetId].map[answer] !== undefined) {
							result[targetId].map[answer]++;
						}
					});
				});

				return Object.entries(result).map(([target_worker_id, { label, map, target_worker_name, uuid }]) => {
					const total = Object.values(map).reduce((sum, val) => sum + val, 0);
					const distribution = Object.entries(map).map(([label, count]) => ({
						label,
						count,
						percentage: total ? ((count / total) * 100).toFixed(1) : '0.0'
					}));

					return {
						target_worker_id,
						label,
						uuid,
						target_worker_name,
						distribution
					};
				});
			}

			function getChartType(item) {
				if (
					item.type === 'multiple_choice' &&
					item.answers.every(a => typeof a === 'string' && /^[1-9]0?$/.test(a))
				) {
					return 'bar';
				}

				if (['radio', 'select', 'checkbox', 'multiple_choice'].includes(item.type)) {
					return 'pie';
				}

				return 'text';
			}

			function getBarChartData(answers) {
				const map = {};
				for (let i = 1; i <= 10; i++) map[i] = 0;
				answers.forEach(a => {
					const val = String(a).trim();
					if (map[val] != null) map[val]++;
				});
				const total = Object.values(map).reduce((sum, v) => sum + v, 0);

				return {
					labels: Object.keys(map),
					datasets: [{
						label: 'Respostas',
						backgroundColor: '#10B981',
						data: Object.values(map),
						percentages: Object.values(map).map(v => total ? ((v / total) * 100).toFixed(1) : 0)
					}]
				};
			}

			const COLOR_PALETTE = [
				'#10B981', '#3B82F6', '#F59E0B', '#EF4444', '#8B5CF6',
				'#EC4899', '#22D3EE', '#F97316', '#84CC16', '#6366F1'
			];

			function getPieChartData(answers, field) {
				const map = {};

				// 🔁 Se existirem opções fixas (como em radio, select, checkbox), use como base
				const allLabels = field?.options?.map(opt => opt.label) || [];

				// Inicializa o map com 0 para todas as opções
				allLabels.forEach(label => {
					map[label] = 0;
				});

				// Conta respostas
				answers.forEach(a => {
					if (Array.isArray(a)) {
						a.forEach(val => {
							val = String(val).trim();
							map[val] = (map[val] || 0) + 1;
						});
					} else {
						const val = String(a).trim();
						map[val] = (map[val] || 0) + 1;
					}
				});

				const labels = allLabels.length > 0 ? allLabels : Object.keys(map);
				const data = labels.map(label => map[label] || 0);
				const total = data.reduce((sum, v) => sum + v, 0);
				const backgroundColor = labels.map((_, i) => COLOR_PALETTE[i % COLOR_PALETTE.length]);

				return {
					labels,
					datasets: [{
						label: 'Respostas',
						backgroundColor,
						data,
						percentages: data.map(v => total ? ((v / total) * 100).toFixed(1) : 0)
					}]
				};
			}

			function getRandomColor() {
				const colors = ['#10B981', '#3B82F6', '#F59E0B', '#EF4444', '#8B5CF6', '#EC4899'];
				return colors[Math.floor(Math.random() * colors.length)];
			}

			function getCompletedCount(data) {
				if (!Array.isArray(data)) return 0;
				return data.filter(dispatch => dispatch.is_completed).length;
			}

			function getCountForLabel(label, answers) {
				let count = 0;
				for (const a of answers) {
					if (Array.isArray(a)) {
						if (a.includes(label)) count++;
					} else {
						if (a === label) count++;
					}
				}
				return count;
			}

			function getPercentageForLabel(label, answers) {
				const count = getCountForLabel(label, answers);
				const total = Array.isArray(answers)
					? answers.reduce((sum, a) => sum + (Array.isArray(a) ? a.length : 1), 0)
					: 0;
				if (total === 0) return '0.0';
				return ((count / total) * 100).toFixed(1);
			}

			async function generateClimateSurveyReport() {
				try {
					if (loadingReport.value) {
						return;
					}
					
					loadingReport.value = true;

					const { data } = await ReportService.generateClimateSurveyReport({
						company: filter.value.company,
						competence: filter.value.competence_date,
						group: selectedGroup.value,
					});

					triggerDownload(data.url);

					loadingReport.value = false;
				} catch (err) {
					loadingReport.value = false;
					console.log(err);
					Swal({
                        title: 'Ocorreu um erro ao obter dados dos envios',
                        text: 'Atualize a página e tente novamente',
                        icon: 'error'
                    });
				}
			}

			function triggerDownload(url) {
				const a = document.createElement('a');
				a.href = url;
				a.target = '_blank';          // navega sem CORS
				a.rel = 'noopener';
				// a.download até pode ser ignorado cross-origin, mas o header já força download
				document.body.appendChild(a);
				a.click();
				a.remove();
			}
			
            return {
				showExportClimate,
				generateClimateSurveyReport,
				getCountForLabel,
				getPercentageForLabel,
				getCompletedCount,
				people,
				selectedPerson,
				filteredResults,
				getPieChartData,
				getBarChartData,
				getChartType,
				pieOptions,
				allResults,
				extractAllAnswers,
				groupedCharts,
				getChartData,
				buildGroupedScoreByTarget,
				selectedGroup,
				chartOptions,
				showResults,
				resultBlocks,
				filter,
				loadingSearchResult,
				onSelectCompetence,
				competenceDate,
				loadingCompanies,
				companies,
				onSelectCompany,
                isEdit,
                loading,
                pageHeader,
                defaultDate,
				textAnswers,
				extractTextAnswers,
				loadingReport
            }
        }
    }

</script>